"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.userRegistrationFormFields = exports.userRegistrationSchema = void 0;
const form_field_types_1 = require("@App/enum/form-field-types");
const zod_1 = require("zod");
const checkbox_size_1 = require("@App/enum/checkbox-size");
const populate_schema_1 = __importDefault(require("@App/forms/v2/helpers/populate-schema"));
const user_info_schema_1 = require("@Entities/schemas/user/user-info-schema");
const error_messages_1 = require("@Const/error-messages");
const emailKey = 'email';
const emailLabel = 'Email Address';
const termsAndConditionsKey = 'termsAndConditions';
const privacyPolicyKey = 'privacyPolicy';
const emailCommunicationsKey = 'emailCommunications';
const userRegistrationSchema = user_info_schema_1.userInfoBaseSchema.merge(zod_1.z.object({
    [termsAndConditionsKey]: zod_1.z
        .boolean({
        required_error: error_messages_1.REQUIRED_MESSAGE,
    })
        .refine((val) => val, {
        message: error_messages_1.REQUIRED_MESSAGE,
    }),
    [privacyPolicyKey]: zod_1.z
        .boolean({
        required_error: error_messages_1.REQUIRED_MESSAGE,
    })
        .refine((val) => val, {
        message: error_messages_1.REQUIRED_MESSAGE,
    }),
    [emailCommunicationsKey]: zod_1.z.boolean().optional(),
}));
exports.userRegistrationSchema = userRegistrationSchema;
const userRegistrationFormFieldsNoSchema = Object.assign(Object.assign({}, user_info_schema_1.userInfoFormFields), { [emailKey]: {
        name: emailKey,
        label: emailLabel,
        type: form_field_types_1.FormFieldTypes.TEXT,
    }, [termsAndConditionsKey]: {
        name: termsAndConditionsKey,
        label: 'Accept',
        size: checkbox_size_1.CheckboxSize.small,
        checked: true,
        type: form_field_types_1.FormFieldTypes.CHECKBOX,
    }, [privacyPolicyKey]: {
        name: privacyPolicyKey,
        label: 'Accept',
        size: checkbox_size_1.CheckboxSize.small,
        checked: true,
        type: form_field_types_1.FormFieldTypes.CHECKBOX,
    }, [emailCommunicationsKey]: {
        name: emailCommunicationsKey,
        label: 'Enroll in marketing communications',
        size: checkbox_size_1.CheckboxSize.small,
        checked: true,
        type: form_field_types_1.FormFieldTypes.CHECKBOX,
    } });
const userRegistrationFormFields = (0, populate_schema_1.default)(userRegistrationFormFieldsNoSchema, userRegistrationSchema);
exports.userRegistrationFormFields = userRegistrationFormFields;
